import { z } from "zod";

export const mobileSchema = z.object({
  mobile: z
    .string()
    .min(11, "شماره موبایل باید حداقل ۱۱ رقم باشد")
    .max(11, "شماره موبایل نباید بیشتر از ۱۱ رقم باشد")
    .regex(
      /^(0[0-9]{2,}[0-9]{8,})|(\u06F0[\u06F0-\u06F9]{2,}[\u06F0-\u06F9]{8,})$/,
      "لطفاً شماره موبایل معتبر وارد کنید"
    ),
});

export type AdlandLandingRequestPayload<
  RequestType extends string = string,
  Data extends object = Record<string, unknown>,
  Email extends string = string
> = {
  requestType: RequestType;
  fullName: string;
  phone: string;
  email: Email;
  data: Data;
};

type OptionWithId = {
  id: string;
};

type OptionWithStringValue = {
  value: string;
};

type OptionWithLabel = {
  label: string;
};

export const requiredShortTextSchema = z.string().trim().min(1).max(100);
export const requiredLongTextSchema = z.string().trim().min(1).max(1000);
export const optionalShortTextSchema = z.string().trim().max(100).optional().default("");
export const optionalLongTextSchema = z.string().trim().max(1000).optional().default("");
export const mobilePhoneSchema = z.string().trim().regex(/^09\d{9}$/);
export const nationalCodeSchema = z.string().trim().regex(/^\d{10}$/);
export const emptyEmailSchema = z.literal("");
export const adlandEmailSchema = z.string().trim().email().or(z.literal(""));
export const birthDateSchema = z
  .string()
  .trim()
  .regex(/^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/);

export const optionIdSchema = (options: readonly OptionWithId[]) =>
  z
    .string()
    .trim()
    .refine((value) => options.some((option) => option.id === value));

export const optionValueSchema = (options: readonly OptionWithStringValue[]) =>
  z
    .string()
    .trim()
    .refine((value) => options.some((option) => option.value === value));

export const optionalOptionValueSchema = (
  options: readonly OptionWithStringValue[]
) =>
  z
    .string()
    .trim()
    .refine(
      (value) => value === "" || options.some((option) => option.value === value)
    )
    .optional()
    .default("");

export const optionLabelSchema = (options: readonly OptionWithLabel[]) =>
  z
    .string()
    .trim()
    .refine((value) => options.some((option) => option.label === value));

export const adlandLandingRequestSchema = z.object({
  requestType: z.string().trim().min(1).max(100),
  fullName: requiredShortTextSchema,
  phone: mobilePhoneSchema,
  email: adlandEmailSchema,
  data: z.record(z.unknown()).default({}),
});

export const createAdlandLandingRequestSchema = <
  RequestType extends string,
  DataSchema extends z.ZodTypeAny,
  EmailSchema extends z.ZodTypeAny = typeof adlandEmailSchema
>(
  requestType: RequestType,
  dataSchema: DataSchema,
  emailSchema: EmailSchema = adlandEmailSchema as unknown as EmailSchema
) =>
  z.object({
    requestType: z.literal(requestType),
    fullName: requiredShortTextSchema,
    phone: mobilePhoneSchema,
    email: emailSchema,
    data: dataSchema,
  });
